import Vue from 'vue';

Vue.filter('amountFormatter', (v) =>
  new Intl.NumberFormat('pl-PL', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(v)
);
